module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-11-7fd63a86a60686b0f98ca40bfdf63be9.jpg";